import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getBlogPost } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { LoadingPage, NotFoundPage } from "@/components/PageStates";
import { Calendar, ArrowLeft, Tag } from "lucide-react";
import DOMPurify from "dompurify";

export default function BlogDetailPage() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getBlogPost(id).then(r => setPost(r.data)).catch(() => setPost(null)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <LoadingPage />;
  if (!post) return <NotFoundPage title="Article introuvable" message="Cet article n'est plus disponible ou a été supprimé." backLabel="Retour au blog" backTo="/blog" />;

  return (
    <div data-testid="blog-detail-page" className="bg-[#FAFAFA] min-h-screen">
      <Navbar />
      <div className="bg-gradient-to-br from-[#1670B9] via-[#2d8fd4] to-[#74CDD9] pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/blog" className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Retour au blog
          </Link>
          <h1 className="font-['Quicksand'] text-3xl sm:text-4xl font-medium text-white mb-4" data-testid="blog-detail-title">{post.title}</h1>
          <div className="flex items-center gap-4 flex-wrap">
            {post.created_at && <span className="flex items-center gap-1 text-sm text-white/70"><Calendar className="w-4 h-4" />{new Date(post.created_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</span>}
            {post.tags?.map(t => <span key={`tag-${t}`} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-white/10 text-white/80 text-xs"><Tag className="w-3 h-3" />{t}</span>)}
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-12">
        {post.image_url && <img src={post.image_url} alt={post.title} className="w-full h-64 md:h-80 object-cover rounded-xl mb-8 shadow-sm" />}
        {post.summary && <p className="text-lg text-slate-600 leading-relaxed mb-8 font-medium border-l-4 border-[#1670B9] pl-4">{post.summary}</p>}
        <div className="prose prose-slate max-w-none [&_img]:rounded-xl [&_a]:text-[#1670B9]" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.content) }} />
      </div>
      <Footer />
    </div>
  );
}
